<div class="progress">
  <div
    class="progress__bar"
    [ngClass]="{ 'progress__bar--complete': percentWidth === 100 }"
    [ngStyle]="{ width: percentWidth + '%' }"
    role="progressbar"
    aria-valuemin="0"
    aria-valuemax="100"
    [attr.aria-valuenow]="percentWidth"></div>
</div>
